import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  PRODUCT_GROUPS,
  PRODUCT_GROUPS_ADD,
  // PRODUCT_GROUPS_ROW_DATA,
  PRODUCT_GROUPS_DELETE,
} from "./actionTypes";
import {
  apiError,
  getProductGroups,
  productGroupsListSuccessful,
  ProductGroupAddSuccessful
  // ProductGroupRowSuccessful,
} from "./actions";
import {getProductGroupsList} from "../Products/actions";

// AUTH related methods
import {
  postAdd,
  // getList,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getProductGroupList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/masters/pgroups/parent/",
      params
    );
    yield put(productGroupsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
// function* ProductGroupRowData({ payload: { pGroupID } }) {
//   try {
//     const response = yield call(getList, "/masters/products/" + pGroupID, {});
//     yield put(
//       ProductGroupRowSuccessful({
//         response: {
//           ...response,
//           ParentGroupLabel: response.parent ? response.parent.name : "",
//           ParentGroup_id: response.parent ? response.parent.id : "",
//         },
//       })
//     );
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
//If user is login then dispatch redux action's are directly from here.
function* AddProductGroup({ payload: { data } }) {
  try {
    if (data.id == null) {
      const response = yield call(postAdd, "/masters/pgroups/", data);
      if (response.status === 201) {
        swal("Your Product Group Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getProductGroups());
        yield put(getProductGroupsList());
      } else {
        swal("Sorry! Unable to added  Product Group. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(ProductGroupAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/pgroups/" + data.id,
        data
      );
      if (response.status === 200) {
        swal("Your Product Group Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getProductGroups());
      } else {
        swal("Sorry! Unable to edit Product Group. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(ProductGroupAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteProductGroup({ payload: { pGroupID } }) {
  try {
    const response = yield call(postDelete, "/masters/products/" + pGroupID);

    if (response.status === 204) {
      swal(" Your Product Group has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getProductGroups());
    } else {
      swal("Sorry! Your  Product Group has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetProductGroupsList() {
  yield takeEvery(PRODUCT_GROUPS, getProductGroupList);
}
export function* watchProductGroupAdd() {
  yield takeEvery(PRODUCT_GROUPS_ADD, AddProductGroup);
}
// export function* watchProductGroupRowData() {
//   yield takeEvery(PRODUCT_GROUPS_ROW_DATA, ProductGroupRowData);
// }

export function* watchProductGroupDelete() {
  yield takeEvery(PRODUCT_GROUPS_DELETE, DeleteProductGroup);
}

function* SubLocationSaga() {
  yield all([
    fork(watchgetProductGroupsList),
    fork(watchProductGroupAdd),
    // fork(watchProductGroupRowData),
    fork(watchProductGroupDelete),
  ]);
}

export default SubLocationSaga;
